import { Input } from '@tymbe/components/inputs';
import classNames from 'classnames';
import { useFieldState } from 'informed';
import { ComponentProps } from 'react';
import { textStyles } from '../style/text-styles';
import { Label } from '../text/components';
import { TyInputControls } from './InputControls';
import { TyInputError } from './InputError';

type TyInputProps<Fields extends object, T> = Omit<
  ComponentProps<typeof Input<Fields, T>>,
  'InputControlsElement'
>;

export const TyInput = <Fields extends object, T>({
  className = '',
  ...props
}: TyInputProps<Fields, T>) => {
  const { focused, showError, error } = useFieldState<string>(props.name);
  const displayError = !!(showError && error);

  return (
    <>
      {props.label && (
        <Label
          className={classNames(displayError && 'text-system-front-error-text')}
        >
          {props.label}
        </Label>
      )}
      <div
        className={classNames(
          className,
          'bg-base-back-inverse',
          'border border-special-outline-default',
          'rounded-lg',
          'p-1',
          'w-full',
          textStyles.pBody2Md,
          focused && 'border-special-outline-selected',
          displayError && 'border-special-outline-error'
        )}
      >
        <Input<Fields, T>
          InputControlsElement={TyInputControls}
          className={classNames(
            'placeholder:font-geistRg',
            'placeholder:text-base-front-3',
            'placeholder:font-normal'
          )}
          {...props}
        />
      </div>
      <TyInputError name={props.name} />
    </>
  );
};
